import { render, staticRenderFns } from "./StatusHistoryOld.vue?vue&type=template&id=a1fd1956&scoped=true&"
import script from "./StatusHistoryOld.vue?vue&type=script&lang=js&"
export * from "./StatusHistoryOld.vue?vue&type=script&lang=js&"
import style0 from "./StatusHistoryOld.vue?vue&type=style&index=0&id=a1fd1956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fd1956",
  null
  
)

export default component.exports